import { Trash2, X } from "lucide-react";

interface ExpirationBannerProps {
  days: number;
  onClose: () => void;
}

/** Port of ExpirationBanner.vue. */
export function ExpirationBanner({ days, onClose }: ExpirationBannerProps) {
  if (!Number.isInteger(days)) {
    return null;
  }

  return (
    <div className="pointer-events-none sticky bottom-0 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8">
      <div className="pointer-events-auto flex items-center justify-between gap-x-6 bg-gray-900 px-6 py-2.5 shadow-xl sm:rounded-xl sm:py-3 sm:pr-3.5 sm:pl-4">
        <p className="text-sm leading-6 text-white">
          {days > 0 ? (
            <span>
              <strong className="font-semibold">Délai expiré</strong>
              <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
                <circle cx="1" cy="1" r="1" />
              </svg>
              Depuis {days} jours
            </span>
          ) : days === 0 ? (
            <span>
              <strong className="font-semibold">Le délai expire</strong>
              <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
                <circle cx="1" cy="1" r="1" />
              </svg>
              Aujourd'hui
            </span>
          ) : null}
        </p>
        <button type="button" onClick={onClose} className="-m-1.5 flex-none p-1.5">
          <span className="sr-only">Fermer</span>
          <X className="h-5 w-5 text-white" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

/** Port of CancelledClaimBanner.vue. */
export function CancelledClaimBanner({ onClose }: { onClose: () => void }) {
  return (
    <div className="pointer-events-none sticky bottom-0 z-50 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8">
      <div className="pointer-events-auto flex items-center justify-between gap-x-6 border-2 border-red-600 bg-red-900 px-6 py-2.5 shadow-xl sm:rounded-xl sm:py-3 sm:pr-3.5 sm:pl-4">
        <p className="text-sm leading-6 text-white">
          <span className="inline-flex items-center">
            <Trash2 className="h-5 w-5" />
            <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
              <circle cx="1" cy="1" r="1" />
            </svg>
            <span>Ce dossier a été clôturé</span>
          </span>
        </p>
        <button type="button" onClick={onClose} className="-m-1.5 flex-none p-1.5">
          <span className="sr-only">Fermer</span>
          <X className="h-5 w-5 text-white" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
